import "./CSS/panic.scss";

import { PageContextUtils, TrackingUtils } from "../../utils";
import { UISelectors, UserContextSelectors } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";

import { LocalizationMessages } from "../../localization/messages";
import PanicTooltip from "./PanicTooltip";
import React from "react";
import { UIActionCreators } from "../../redux/action-creators";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { SVGIcon2 } from "../common/SVGIconV2";

export const PanicContainer = () => {
  const { formatMessage } = useIntl();
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const { subBrandId } = PageContextUtils.getBrandData();
  const dispatch = useDispatch();
  const panicTooltipClosed = useSelector(UISelectors.panicTooltipClosed);

  const closePanicTooltip = useCallback(
    data => dispatch(UIActionCreators.closePanicTooltip(data)),
    [dispatch]
  );

  if (!isAuthenticated) return null;

  const handleClick = async () => {
    if (isMobile) {
      console.log("PanicButtonClicked - mobile");
      TrackingUtils.sendAnalytics({
        dataCategory: `${subBrandId} - Mobile - Panic_Button`,
        dataAction: "click",
        dataLabel: "panic_button_click",
        dataValue: ""
      });
      closePanicTooltip(false);
    }
  };

  const handleHover = async () => {
    if (!isMobile) {
      console.log("PanicButtonClicked - PC");
      TrackingUtils.sendAnalytics({
        dataCategory: `${subBrandId} - PC - Panic_Button`,
        dataAction: "click",
        dataLabel: "panic_button_click",
        dataValue: ""
      });
      closePanicTooltip(false);
    }
  };

  const messages = {
    button: LocalizationMessages.panicMessageButton,
    content: LocalizationMessages.panicMessageContent,
    link: LocalizationMessages.panicMessageLink
  };

  return (
    <div className="panic-button-container">
      <button
        className="panic-button"
        onClick={handleClick}
        onMouseOver={handleHover}
      >
        <SVGIcon2 className="24h" iconName="24h" asBackground />
        {formatMessage(messages.button)}
      </button>
      {!panicTooltipClosed && <PanicTooltip isMobile={isMobile} />}
    </div>
  );
};

export default React.memo(PanicContainer);
